import Marquee from "react-fast-marquee";
import { BRAND } from "@/data/content";

/**
 * EditorialMarquee — one slow, discreet ribbon. Repeats the pillars + promise.
 */
export const EditorialMarquee = () => {
  const items = [...BRAND.pillars, "No upfront fees", "Human approval", "Your decisions"];
  return (
    <div className="border-y border-white/5 bg-ff-slate/40 py-6" data-testid="editorial-marquee">
      <Marquee speed={26} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <span key={i} className="mx-8 flex items-center gap-8">
            <span className="font-display text-2xl font-medium uppercase tracking-[0.18em] text-ff-ivory/70 md:text-3xl">
              {item}
            </span>
            <span className="text-ff-ember">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};

export default EditorialMarquee;
